export { default } from './BorderedFlexBox';
